<div class="mx-auto w-full p-4">
  <div
    style="background-image: url('assets/images/stepper-bg.png')"
    class="mb-8 flex flex-col gap-4 rounded-xl bg-cover bg-no-repeat p-6"
  >
    <div class="flex items-center justify-center text-white">
      {{ currentStep > 3 ? 'Review Finished' : 'Step' + (currentStep + 1) }}
    </div>
    <div class="flex items-center justify-center">
      @for (step of steps; track step; let i = $index) {
      <div class="flex items-center">
        <div
          class="relative flex h-8 w-8 items-center justify-center rounded-full border-2"
          [class.border-green-500]="currentStep > i"
          [class.border-white]="currentStep === i"
          [class.border-neutral-300]="currentStep !== i && currentStep < i"
        >
          @if (currentStep <= i) { <span class="text-xs text-white">{{ i + 1 }}</span>
          } @if (currentStep > i) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-green-500"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414L8 15.414l-4.707-4.707a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd"
            />
          </svg>
          }
        </div>
        <div
          class="ml-2 text-sm text-neutral-300"
          [class.!text-green-500]="currentStep > i"
          [class.text-white]="currentStep === i"
          [class.text-neutral-300]="currentStep !== i && currentStep < i"
        >
          {{ step.title }}
        </div>
        @if (i < steps.length - 1) {
        <div
          class="mx-2 h-[2px] w-8 flex-1 bg-neutral-300"
          [class.!bg-green-500]="currentStep > i"
          [class.bg-white]="currentStep === i"
          [class.bg-neutral-300]="currentStep !== i && currentStep < i"
        ></div>
        }
      </div>
      }
    </div>
  </div>

  <div class="">
    @let course = course$ | async; @switch (currentStep) { @case (0) {
    <div>
      <app-intended [isDefaultView]="false"></app-intended>
    </div>
    } @case (1) {
    <div>
      <app-general [isDefaultView]="false"></app-general>
    </div>
    } @case (2) {
    <div>
      @if(course?.course_mode === 'video_based'){
      <app-curriculum [isDefaultView]="false"></app-curriculum>
      }@else {
      <app-course-schedule [isDefaultView]="false"></app-course-schedule>
      }
    </div>
    } @case (3) {
    <div>
      <app-pricing [isDefaultView]="false"></app-pricing>
    </div>
    } @case (4) {
    <div class="flex justify-center">
      <app-intended #intend [isDefaultView]="false" class="hidden"></app-intended>
      <ng-container *ngTemplateOutlet="finishedReview"></ng-container>
    </div>
    } }
  </div>

  <div [class]="currentStep > 3 ? 'justify-center' : 'justify-between'" class="mt-4 flex">
    @if (currentStep > 0) {
    <button
      (click)="prevStep()"
      class="flex items-center gap-1 rounded-md border border-neutral-800 px-6 py-1 text-neutral-800"
    >
      <svg-icon src="@assets/images/icons/arrow-left.svg" class="btn-icon w-4"></svg-icon>
      Back
    </button>
    }
    <span></span>
    @if (currentStep < 3) {
    <button (click)="nextStep()" class="flex items-center gap-1 rounded-md bg-teal-50 px-6 py-1 text-teal-600">
      Next
      <svg-icon src="@assets/images/icons/arrow-right.svg" class="btn-icon w-4"></svg-icon>
    </button>
    } @else { @if (currentStep < 4) {
    <button (click)="nextStep()" class="rounded-md bg-teal-50 px-6 py-1 text-teal-600">Finished</button>
    } }
  </div>

  <!-- Finishing -->
  <ng-template #finishedReview>
    <div class="flex max-w-xl flex-col items-center gap-4 rounded-xl bg-neutral-50 p-6 shadow-lg">
      <h3 class="text-center">You have successfully completed the review process!</h3>
      <div class="flex items-center gap-3">
        <button class="btn-outline" (click)="actionEvent('reject')">
          <span>Reject</span>
        </button>
        <button class="btn-teal" (click)="actionEvent('accept')">
          <span>Accept</span>
        </button>
      </div>
    </div>
  </ng-template>
</div>
